import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import { storage } from "../../../../../scopedStorage";

const EMPTY_STATE = { amount: "", reason: "" };

const SubmitModal = ({ show, onHide, onSubmitted, onExistingRequest }) => {
  const [form, setForm] = useState(EMPTY_STATE);
  const [submitting, setSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (show) {
      setForm(EMPTY_STATE);
      setFieldErrors({});
    }
  }, [show]);

  const token = storage.getItem("token");
  const authHeaders = { Authorization: `Bearer ${token}` };

  const isValid = () => Number(form.amount) >= 0.01;

  const handleSubmit = async () => {
    if (!isValid()) return;
    setSubmitting(true);
    setFieldErrors({});
    try {
      const { data } = await axios.post(
        `${switchEndpoint}/collection-center/center-float-requests`,
        {
          amount: Number(form.amount),
          reason: form.reason.trim() || undefined,
        },
        { headers: authHeaders }
      );
      toast.success("Float request submitted", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
      onSubmitted(data);
    } catch (error) {
      const response = error?.response;
      // One open request at a time — the API 400s with the existing
      // request's reference rather than a generic failure. Send the
      // person to that request instead of just showing an error.
      if (response?.status === 400 && response.data?.errors?.reference_no) {
        onExistingRequest(response.data.message);
      } else if (response?.status === 422) {
        setFieldErrors(response.data?.errors || {});
        toast.error(response.data?.message || "The request could not be submitted.", {
          position: "top-right",
          autoClose: 4000,
          theme: "light",
        });
      } else {
        toast.error(response?.data?.message || "The request could not be submitted.", {
          position: "top-right",
          autoClose: 4000,
          theme: "light",
        });
      }
    }
    setSubmitting(false);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>Request Float</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group style={{ marginBottom: 14 }}>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
            Amount (₦) <span style={{ color: "#ef4444" }}>*</span>
          </Form.Label>
          <Form.Control
            type="number"
            min={0.01}
            step="0.01"
            value={form.amount}
            onChange={(e) => setForm((prev) => ({ ...prev, amount: e.target.value }))}
            placeholder="e.g. 250000"
            size="sm"
            isInvalid={!!fieldErrors.amount}
          />
          {fieldErrors.amount && (
            <Form.Text style={{ color: "#dc2626" }}>{fieldErrors.amount[0]}</Form.Text>
          )}
        </Form.Group>

        <Form.Group style={{ marginBottom: 4 }}>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>Reason</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            size="sm"
            maxLength={2000}
            value={form.reason}
            onChange={(e) => setForm((prev) => ({ ...prev, reason: e.target.value }))}
            placeholder="e.g. Wallet exhausted after a heavy dropoff day"
            isInvalid={!!fieldErrors.reason}
          />
          {fieldErrors.reason && (
            <Form.Text style={{ color: "#dc2626" }}>{fieldErrors.reason[0]}</Form.Text>
          )}
          <Form.Text style={{ color: "#9ca3af" }}>
            {form.reason.length}/2000
          </Form.Text>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide} size="sm" disabled={submitting}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit} size="sm" disabled={!isValid() || submitting}>
          {submitting ? "Submitting..." : "Submit Request"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubmitModal;
